export const GroupField = ({ field, renderField }) => (
  <div className="border border-gray-200 rounded-md p-4 space-y-4">
    {field.groupLabel && (
      <h4 className="font-medium text-gray-700">{field.groupLabel}</h4>
    )}
    {field.fields?.map((subField) => (
      <div key={subField.id}>
        {renderField({
          ...subField,
          id: `${field.id}.${subField.id}`
        })}
      </div>
    ))}
  </div>
);